import adminApiClient from './api.admin';
import ADMIN_API_ENDPOINTS from './endpoints.admin';
class AdminPlansService {
    async list() {
        return adminApiClient.get(ADMIN_API_ENDPOINTS.PLANS.BASE);
    }
    async getActive() {
        return adminApiClient.get(ADMIN_API_ENDPOINTS.PLANS.ACTIVE);
    }
    async get(id) {
        return adminApiClient.get(ADMIN_API_ENDPOINTS.PLANS.BY_ID(id));
    }
    async create(payload) {
        return adminApiClient.post(ADMIN_API_ENDPOINTS.PLANS.BASE, payload);
    }
    async update(id, payload) {
        return adminApiClient.put(ADMIN_API_ENDPOINTS.PLANS.BY_ID(id), payload);
    }
    async remove(id) {
        return adminApiClient.delete(ADMIN_API_ENDPOINTS.PLANS.BY_ID(id));
    }
    async toggleActive(id) {
        return adminApiClient.put(ADMIN_API_ENDPOINTS.PLANS.TOGGLE_ACTIVE(id));
    }
}
export const adminPlansService = new AdminPlansService();
export default adminPlansService;
